<div class="min-h-screen">
  @if(loading)
  {
  <div class="min-h-screen flex justify-center items-center w-full bg-black/80 dark:bg-black/85">
    <span class="loading loading-spinner text-secondary"></span>
  </div>
  }
  @else {

  <div class="container flex md:flex-row flex-col-reverse md:items-start gap-3">
    <div
      class="info flex flex-col gap-3 md:w-4/6 p-4 self-stretch bg-gradient-to-r from-base-200 to-base-300 rounded-2xl ">
      <h2 class=" text-2xl font-bold">{{seriesDetails.original_name}}</h2>
      <div class="flex items-center gap-2 justify-between">
        <div class="rate flex items-center text-warning text-shadow-xs">
          <ng-icon name="solarStarBold" />
          <span class=" font-semibold">{{(seriesDetails.popularity%10)
            <5?((seriesDetails.popularity%10)+5).toFixed(1):(seriesDetails.popularity%10).toFixed(1)}} </span>
        </div>
        <h2 class="text-neutral/50 font-bold">{{seriesDetails.first_air_date}}</h2>
      </div>
      <h2 class="font-bold text-accent text-xl">Overview</h2>
      <p class=" text-base-content max-w-lg">{{seriesDetails.overview}}</p>
      <!-- TrailerLink -->
      <a [href]="trailerLink" target="_blank" rel="noopener noreferrer" class=" link link-primary">
        <i class="fa-solid fa-link"></i>
        Explore Trailer
      </a>
      <div class="categories flex flex-wrap gap-2">
        @for (category of seriesCats; track $index) {
        <div class=" badge badge-accent text-xs font-semibold ">
          {{category}}
        </div>
        }
      </div>
      <h3 class="text-3xl text-end font-bold text-primary text-shadow-xs">{{formatCurrency(seriesDetails.price)}}</h3>
      <div class="flex-1"></div>
      <!-- Buttons - positioned at the bottom with -->
      <div class="flex flex-col sm:flex-row gap-4 my-3">
        <button class="btn btn-secondary sm:flex-1 " (click)="addToWatchList()">
          @if (isInWatchList()) {
          <ng-icon name="faSolidBookmark" />
          Remove from WatchList
          }@else {
          <ng-icon name="faBookmark" />
          Add to WatchList
          }
        </button>
        <button class="btn sm:flex-[2] btn-primary" (click)="addToCart()">
          <ng-icon name="faSolidCartShopping" class="text-white" />
          {{ isInCart() ? 'Remove from Cart' : 'Add to Cart' }}
        </button>
      </div>
    </div>
    <img class="md:w-2/6 aspect-[3/4] w-full rounded-2xl object-cover " src={{getImageSrc()}}
      alt='{{seriesDetails.poster_path}}' />
  </div>

  <div class="container movies-sec my-3">
    <h2 class="relative text-lg font-bold pb-2 border-b-4 border-secondary">
      Related Series</h2>
    <div class="related-movies grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 my-4">
      <div class="item flex-1" *ngFor="let series of displayedRelatedseries ; let i =index">
        <app-mediaCard [mediaItem]="series"></app-mediaCard>
      </div>
    </div>
  </div>
  }

</div>